// @ts-check
import React, { Component } from 'react';
import { Row, Widget } from 'shared/containers/portal_layout';
import LoadingContent from 'shared/components/LoadingContent';
import api from 'utils/api';
import styles from './Edit.module.scss';
import Icon from 'shared/components/Icon';
import { RIEInput } from 'riek';
import PromiseButton from 'shared/components/PromiseButton';
import FlashMessageActions from 'shared/actions/FlashMessageActions';

class Edit extends Component {
  constructor(props) {
    super(props);
    this.state = { checklistItems: null, entityName: null };
    this.remove = this.remove.bind(this);
    this.add = this.add.bind(this);
    this.rename = this.rename.bind(this);
    this.setNewItemNameRef = this.setNewItemNameRef.bind(this);
    this.saveChecklist = this.saveChecklist.bind(this);
  }

  componentDidMount() {
    api
      .get(
        `${this.props.apiPrefix}/entities/${this.props.entityId}/referral_checklist_template/edit`
      )
      .then(response => {
        this.setState({
          checklistItems: response.data.checklistItems,
          entityName: response.data.entityName,
        });
      });
  }

  remove(removedIdx) {
    this.setState({
      checklistItems: this.state.checklistItems.filter((el, idx) => idx !== removedIdx),
    });
  }

  rename(renameIdx, value) {
    this.setState({
      checklistItems: this.state.checklistItems.map((el, idx) => (idx !== renameIdx ? el : value)),
    });
  }

  add(e) {
    e.preventDefault();
    this.setState({ checklistItems: [...this.state.checklistItems, this.newItemName.value] });
    this.newItemName.value = '';
  }

  saveChecklist() {
    return api
      .putWithoutDefaultRejectionHandling(
        `${this.props.apiPrefix}/entities/${this.props.entityId}/referral_checklist_template`,
        {
          checklist_items: this.state.checklistItems,
        }
      )
      .then(
        response => {
          FlashMessageActions.flashSuccess({
            message: 'You have successfully saved the default checklist',
          });
          return null;
        },
        error => {
          FlashMessageActions.flashError({
            message: "I'm sorry, something went wrong while saving the default checklist",
          });
          return null;
        }
      );
  }

  setNewItemNameRef(input) {
    this.newItemName = input;
  }

  render() {
    if (!this.state.checklistItems) return <LoadingContent />;
    return (
      <PresentationComponent
        checklistItems={this.state.checklistItems}
        remove={this.remove}
        add={this.add}
        rename={this.rename}
        setNewItemNameRef={this.setNewItemNameRef}
        saveChecklist={this.saveChecklist}
        entityName={this.state.entityName}
      />
    );
  }
}

const PresentationComponent = ({
  entityName,
  saveChecklist,
  checklistItems,
  remove,
  rename,
  add,
  setNewItemNameRef,
}) => (
  <div>
    <Row>
      <Widget title="Referral Checklist Template" span={12} nopadding>
        <div className={styles.referral_checklist_widget_content}>
          <p>
            To update the template for the checklist that will be added to each incoming referral,
            edit the checklist template below by adding, updating, and removing items.
          </p>
          <p>
            When you're finished editing the checklist template, click "Save Checklist Template"
            below to save your changes.
          </p>
          <p>Changes to the checklist template will only affect future referrals.</p>

          <div className={styles.referral_checklist_container}>
            <div className={styles.referral_checklist_header}>
              <h4 className={styles.checklist_heading}>Referral Checklist (Template)</h4>
            </div>
            <div className={styles.referral_checklist_body}>
              {checklistItems.length === 0 ? (
                <h4>No Items</h4>
              ) : (
                <ul className={styles.referral_checklist_items} data-spec-id="checklist-items">
                  {checklistItems.map((item, idx) => (
                    <li key={idx} className={styles.referral_checklist_item}>
                      <div className={styles.referral_checklist_item_checkbox}>
                        <input type="checkbox" />
                      </div>
                      <div
                        className={styles.referral_checklist_item_label}
                        data-spec-id="checklist-item-name-container"
                      >
                        <EditInPlace
                          value={item}
                          propName="value"
                          change={({ value }) => rename(idx, value)}
                        />
                      </div>
                      <div className={styles.referral_checklist_item_actions}>
                        <span
                          title="Remove"
                          className={styles.remove}
                          data-spec-id={`remove-checklist-item-${idx}`}
                          onClick={() => remove(idx)}
                        >
                          <Icon name="bin" />
                        </span>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
              <div className={styles.new_item_form_container}>
                <form className="form-inline" onSubmit={add}>
                  <div className="input-append">
                    <input
                      ref={setNewItemNameRef}
                      className="span12"
                      name="newItemName"
                      type="text"
                    />
                    <button className="btn" type="submit">
                      Add
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.form_actions}>
          <PromiseButton type="button" className="btn btn-primary" onClick={saveChecklist}>
            Save Checklist Template
          </PromiseButton>
        </div>
      </Widget>
    </Row>
  </div>
);

const EditInPlace = props => {
  let ref = null;
  return (
    <span>
      <RIEInput
        ref={i => {
          ref = i;
        }}
        {...props}
      />
      <span className={styles.edit}>
        <Icon name="pencil" onClick={() => ref.startEditing()} />
      </span>
    </span>
  );
};

export default Edit;
